import Cookies from 'js-cookie'

/**
 * Get user ID from cookies
 * @returns {string} User ID or empty string if not found
 */
export function getUserId() {
  return Cookies.get('user_id') || '';
}

/**
 * Remove user ID from cookies
 */
export function removeUserId() {
  Cookies.remove('user_id');
}

/**
 * Get user email from cookies
 * @returns {string} User email or empty string if not found
 */
export function getUserEmail() {
  return Cookies.get('user_email') || '';
}

/**
 * Remove user email from cookies
 */
export function removeUserEmail() {
  Cookies.remove('user_email');
}

/**
 * Set user email in cookies
 * @param {string} email - User email to store
 */
export function setUserEmail(email) {
  Cookies.set('user_email', email);
}

/**
 * Check if user is logged in
 * @returns {boolean} True if user is logged in, false otherwise
 */
export function isLoggedIn() {
  return !!getUserId();
}

/**
 * Get user name from cookies
 * @returns {string} User name or empty string if not found
 */
export function getUserName() {
  return Cookies.get('user_name') || '';
}

/**
 * Get user avatar URL from cookies
 * @returns {string} User avatar URL or empty string if not found
 */
export function getUserAvatar() {
  return Cookies.get('user_avatar_address_small') || '';
}

/**
 * Get user creator level from cookies
 * @returns {string} User creator level or 'Basic' if not found
 */
export function getUserCreatorLevel() {
  return Cookies.get('creator_functionality_level') || 'Basic';
} 

/**
 * Get user type from cookies
 * @returns {string} User type or 'Basic' if not found
 */
export function getUserType() {
  return Cookies.get('user_type') || 'Basic';
}
